import { z } from "zod";

/**
 * An MCP tool's `inputSchema`: a JSON Schema whose root is an object.
 *
 * Only the root `type` is judged; the rest of the JSON Schema is kept verbatim,
 * because it is hashed and because what it may contain is JSON Schema's to define.
 *
 * Prefixed `McpTool` although it sits in the contract folder: an unprefixed
 * `InputSchemaSchema` is ambiguous in the `@nexus/types/json-schemas` barrel.
 */
export const McpToolInputSchemaSchema = z.looseObject({
  type: z.literal("object")
});

export type McpToolInputSchema = z.infer<typeof McpToolInputSchemaSchema>;
